import { Typography } from '@material-ui/core';
import React from 'react';

const SimpleKeyValueText = ({ label, value, valueContent, variant, nullPlaceholder }) => {
  return (
    <Typography variant={variant}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', columnGap: '.3em' }}>
        <span style={{ fontWeight: 'bold' }}>{`${label}:`}</span>
        {valueContent || ` ${value || nullPlaceholder || ''}`}
      </div>
    </Typography>
  );
};

export default SimpleKeyValueText;
